// Modified from https://gist.github.com/gwwar/2166393

// test for ie: turn on conditional comments
var jscript/*@cc_on=@_jscript_version@*/;
var styleProp = (jscript) ? "display" : "pointerEvents";

function atPoint (clientX, clientY, filter, bound, lastElement) {
    //support for child iframes
    var d = (lastElement) ? lastElement.ownerDocument : document;
    var $el;
    // No support from FF until this bug is closed:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1164427
    var efp = d.elementsFromPoint || d.msElementsFromPoint;
    if (efp) {
        var elements = efp.call(d, clientX, clientY);
        if (filter) {
            var found;
            for (var i = 0; i < elements.length; i++) {
                $el = $(elements[i]);
                if ($el.is(filter) || (bound && $el.is(bound))) {
                    found = elements[i];
                    break;
                }
            }
            if (found && $(found).is(filter)) {
                return [found];
            } else {
                return [];
            }
        } else if (_.isArray(elements)) {
            return elements;
        } else {
            // msElementsFromPoint returns a nodelist, convert to an array
            // for loop is faster than Array.prototype.slice in IE
            var els = [];
            for (var j = 0, len = elements.length; j < len; j++) {
                els[j] = elements[j];
            }
            return els;
        }
    } else {
        //the last element in the list
        lastElement = lastElement || document.body.parentNode;

        var element = d.elementFromPoint(clientX, clientY);
        if (element && element.nodeType == 3) { // avoid text nodes
            element = element.parentNode;
        }
        $el = $(element);
        if (!element || (bound && $el.is(bound))) {
            return [];
        }
        if (filter) {
            if ($el.is(filter)) {
                return [element];
            } else {
                var closest = $el.closest(filter);
                if (closest.is(filter) && (!bound || closest.closest(bound).is(bound))) {
                    return [closest[0]];
                    // return [];
                } else {
                    return [];
                }
            }
        }
        if (element === lastElement || element.nodeName === "HTML") {
            return [element];
        } else {
            var style = element.style[styleProp];
            element.style[styleProp]="none"; //let us peak at the next layer
            var result = [element].concat(atPoint(clientX,clientY,filter,bound,lastElement));
            element.style[styleProp]= style; //restore
            return result;
        }
    }
}

module.exports = atPoint;



//////////////////
// WEBPACK FOOTER
// ./app/src/lib/atpoint.js
// module id = 88d4
// module chunks = 1